import styled from 'styled-components';

export const PlantingLots = styled.div`
  background: white;
  min-height: 100%;
`
